import React from 'react';
import { Sidebar } from 'primereact/sidebar';

export const SidebarHospitalizationHistory = (props) => {

    const {
        visibleHospitalizationHistory,
        setVisibleHospitalizationHistory,
        hospitalizationHistory,
        loadingHospitalizationHistory
    } = props;


    const formatDate = (date) => {

        if (!date) return "Fecha no disponible";

        return new Date(date).toLocaleString("es-MX", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        });
    };


    return (
        <Sidebar
            className="sidebarCustom hospitalization-history-sidebar"
            visible={visibleHospitalizationHistory}
            position="top"
            onHide={() =>
                setVisibleHospitalizationHistory(false)
            }
            style={{
                height: 'auto',
                maxHeight: '55vh',
                overflowY: 'auto',
                padding: '0',
                borderRadius: '0 0 12px 12px'
            }}
        >

            <div className="hospital-history-container">
                <div className="hospital-history-title-container">
                    <div className="hospital-history-title-icon">
                        <i className="fa fa-hospital-o"></i>
                    </div>

                    <div className="hospital-history-title-info">
                        <h5>Historial de hospitalizaciones</h5>
                        <span>
                            Seguimiento de ingresos hospitalarios del paciente
                        </span>
                    </div>

                    {hospitalizationHistory?.length > 0 && (
                        <div className="hospital-history-total">
                            <strong>{hospitalizationHistory.length}</strong>
                            <small>
                                {hospitalizationHistory.length === 1
                                    ? "registro"
                                    : "registros"}
                            </small>
                        </div>
                    )}

                    <button
                        type="button"
                        className="hospital-history-close"
                        onClick={() => setVisibleHospitalizationHistory(false)}
                        title="Cerrar"
                    >
                        <i className="fa fa-times"></i>
                    </button>
                </div>

                {loadingHospitalizationHistory ? (
                    <div className="hospital-history-loading">
                        <i className="fa fa-spinner fa-spin"></i>
                        <span>
                            Recuperando historial...
                        </span>
                    </div>

                ) : hospitalizationHistory?.length > 0 ? (
                    <div className={`hospital-custom-timeline ${hospitalizationHistory.length <= 3 ? "few-records" : "many-records" }`}>
                        {hospitalizationHistory.map((item, index) => {
                            const isLatest = index === 0;
                            return (
                                <div className="hospital-custom-timeline-item" key={item.id_work_order || index}>
                                    <div className="hospital-custom-timeline-date">
                                        <i className="fa fa-calendar-o"></i>
                                        <span>
                                            {formatDate(item.created_at)}
                                        </span>
                                    </div>

                                    <div className="hospital-custom-timeline-track">
                                        <div className="hospital-custom-line"></div>
                                        <div className={`hospital-history-marker ${isLatest ? "latest" : "previous" }`}>
                                            <i className="fa fa-hospital-o"></i>
                                        </div>
                                    </div>

                                    <div className={`hospital-history-modern-card ${isLatest ? "latest" : "previous" }`}>
                                        <div className="hospital-history-modern-top">
                                            <div className="hospital-history-modern-status">
                                                <div className="hospital-history-modern-status-icon">
                                                    <i className="fa fa-hospital-o"></i>
                                                </div>
                                                <span> 
                                                    {isLatest ? "Hospitalización más reciente" : "Hospitalización anterior"}
                                                </span>
                                            </div>

                                            {isLatest && (
                                                <span className="hospital-history-modern-badge">
                                                    Reciente
                                                </span>
                                            )}
                                        </div>

                                        <div className="hospital-history-modern-body">
                                            <div className="hospital-history-modern-order">
                                                <div className="hospital-history-modern-order-info">
                                                    <span className="hospital-history-modern-label">
                                                        NIM
                                                    </span>

                                                    <strong title={item.nim}>
                                                        {item.nim || "Sin NIM"}
                                                    </strong>
                                                </div>

                                                <div className="hospital-history-modern-date">
                                                    <i className="fa fa-calendar-o"></i>
                                                    <span>
                                                        {formatDate(item.created_at)}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="hospital-history-modern-comment">
                                                <div className="hospital-history-modern-comment-header">
                                                    <i className="fa fa-commenting-o"></i>
                                                    <span>
                                                        Motivo de hospitalización
                                                    </span>
                                                </div>

                                                <div className="hospital-history-modern-comment-content">
                                                    {item.comment?.trim()
                                                        ? item.comment
                                                        : "Sin comentarios de hospitalización"}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className="hospital-history-empty">
                        <div className="hospital-history-empty-icon">
                            <i className="fa fa-hospital-o"></i>
                        </div>

                        <strong>
                            Sin hospitalizaciones anteriores
                        </strong>

                        <span>
                            No existen registros de hospitalización para este paciente.
                        </span>
                    </div>
                )}
            </div>
        </Sidebar>
    );
};




